export default {
  methods: {
    getLeadershipTitle (researcher) {
      if (researcher.role && researcher.founder) {
        return `${researcher.role} - Founder`
      } else if (researcher.founder) {
        return 'Founder'
      } else if (researcher.role) {
        return researcher.role
      }
    }
  },
  computed: {
    industryAndTypeString () {
      let output = ''
      if (this.organisation.industries) {
        const relevantIndustries = this.organisation.industries.filter(i => {
          return i !== 'Finance' && i !== 'Financial Services'
        })
        if (!this.isEmpty(relevantIndustries)) {
          output = `${relevantIndustries.join(', ')} - `
        }
      }

      output = `${output}${this.organisation.organisation_types.join(' and ')}`
      return output
    },
    hasSpinoffs () {
      return Array.isArray(this.organisation.references) &&
        this.organisation.references.find(reference => reference.name === 'has_spinoff')
    },
    isSpinoff () {
      return this.organisation.organisation_types?.indexOf('Spinoff') >= 0
    },
    isIncubator () {
      return this.organisation.organisation_types?.indexOf('Incubator') >= 0
    },
    isInvestor () {
      return this.organisation.organisation_types?.indexOf('Investor') >= 0
    },
    investorFundsData () {
      if (!this.isInvestor || this.isEmpty(this.organisation.investor_funds)) return null
      const funds = this.organisation.investor_funds.reduce((max, fund) => {
        return !fund.start_year || max.start_year > fund.start_year ? max : fund
      })
      return funds
    },
    spinOffParent () {
      if (!this.isSpinoff) return null
      const reference = Array.isArray(this.organisation.references) &&
        this.organisation.references.find(reference => reference.name === 'spinoff_from')

      return reference?.organisations?.[0]
    },
    relatedOrganisations () {
      if (!Array.isArray(this.organisation.references)) return []
      const references = this.organisation.references
      const relationTypes = [
        { name: 'acquired_by', title: '<span class="t-600">Acquired</span> by' },
        // { name: 'has_acquired', title: '<span class="t-600">Has acquired</span>' },
        { name: 'spinoff_from', title: `<span class="t-600">${this.organisation.industries?.join(', ') ?? ''} Spinoff</span> from` },
        // { name: 'portfolio_from', title: '<span class="t-600">Portfolio Company</span> of' },
        { name: 'partnered_with', title: '<span class="t-600">Partnership</span> with' },
        { name: 'parent', title: '<span class="t-600">Owned</span> by' }
      ]
      const groupedOrganisationList = []
      relationTypes.forEach(t => {
        const matchedReferences = references.filter(r => r.name === t.name)
        if (!this.isEmpty(matchedReferences)) {
          groupedOrganisationList.push({
            title: t.title,
            organisations: matchedReferences.map(reference => reference.organisations).flat()
          })
        }
      })
      return groupedOrganisationList
    },
    headQuarters () {
      let hq = this.organisation?.locations?.find(o => o.head_quarters)
      if (!hq) {
        hq = this.organisation?.locations?.[0]
      }
      return hq
    },
    locationString () {
      const location = this.headQuarters
      if (!location) return ''
      if (location.country?.name) {
        return `${location.city ? `${location.city}, ` : ''}${location.country.name}`
      } else if (location.city) {
        return location.city
      }
      return ''
    },
    country () {
      if (this.headQuarters) return this.headQuarters.country
      return null
    }
  }
}
